import {Context} from './Context';
import {CatalogController} from '../Controller/CatalogController';

export class AppData {
  readonly catalogController: CatalogController;

  constructor(private readonly context: Context) {
    this.catalogController = new CatalogController(context.repos.catalogsRepository);
  }
}
